/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const ArrowDownIcon = ({ size, ...props }) => (React.createElement("svg", { viewBox: "0 0 10 6", fill: "currentColor", width: size || '1em', height: size || '1em', ...props },
    React.createElement("path", { fill: "currentColor", id: "a", d: "M4.9,4.2L0.8,0.1L0.1,0.8l4.1,4.1L4.1,5.1l0.7,0.7l0.1-0.1l0.1,0.1l0.7-0.7L5.7,4.9l4.1-4.1L9.1,0.1L4.9,4.2z" })));
ArrowDownIcon.displayName = 'ArrowDownIcon';
export default ArrowDownIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=ArrowDownIcon.js.map